"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-sdk-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class InfoApi extends runtime.BaseAPI {
    /**
     * Get entropy from the device\'s RNG.
     * Get entropy
     */
    async getEntropyRaw(requestParameters, initOverrides) {
        if (requestParameters.GetEntropyRequest === null || requestParameters.GetEntropyRequest === undefined) {
            throw new runtime.RequiredError('GetEntropyRequest', 'Required parameter requestParameters.GetEntropyRequest was null or undefined when calling getEntropy.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system/info/get-entropy`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.GetEntropyRequestToJSON)(requestParameters.GetEntropyRequest),
        }, initOverrides);
        return new runtime.BlobApiResponse(response);
    }
    /**
     * Get entropy from the device\'s RNG.
     * Get entropy
     */
    async getEntropy(GetEntropyRequest, initOverrides) {
        const response = await this.getEntropyRaw({ GetEntropyRequest: GetEntropyRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Get device features object
     * Get features
     */
    async getFeaturesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system/info/get-features`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.TypesFeaturesFromJSON)(jsonValue));
    }
    /**
     * Get device features object
     * Get features
     */
    async getFeatures(initOverrides) {
        const response = await this.getFeaturesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get public key associated with a particular BIP-32 node.
     * Get public key
     */
    async getPublicKeyRaw(requestParameters, initOverrides) {
        if (requestParameters.GetPublicKeyRequest === null || requestParameters.GetPublicKeyRequest === undefined) {
            throw new runtime.RequiredError('GetPublicKeyRequest', 'Required parameter requestParameters.GetPublicKeyRequest was null or undefined when calling getPublicKey.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system/info/get-public-key`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.GetPublicKeyRequestToJSON)(requestParameters.GetPublicKeyRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetPublicKey200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get public key associated with a particular BIP-32 node.
     * Get public key
     */
    async getPublicKey(GetPublicKeyRequest, initOverrides) {
        const response = await this.getPublicKeyRaw({ GetPublicKeyRequest: GetPublicKeyRequest }, initOverrides);
        return await response.value();
    }
    /**
     * Dump device coins table.
     * List coins
     */
    async listCoinsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system/info/list-coins`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.TypesCoinFromJSON));
    }
    /**
     * Dump device coins table.
     * List coins
     */
    async listCoins(initOverrides) {
        const response = await this.listCoinsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Confirm device connectivity, optionally with on-device confirmation.
     * Ping
     */
    async pingRaw(requestParameters, initOverrides) {
        if (requestParameters.PingRequest === null || requestParameters.PingRequest === undefined) {
            throw new runtime.RequiredError('PingRequest', 'Required parameter requestParameters.PingRequest was null or undefined when calling ping.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("apiKey", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/system/info/ping`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PingRequestToJSON)(requestParameters.PingRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.Ping200ResponseFromJSON)(jsonValue));
    }
    /**
     * Confirm device connectivity, optionally with on-device confirmation.
     * Ping
     */
    async ping(PingRequest, initOverrides) {
        const response = await this.pingRaw({ PingRequest: PingRequest }, initOverrides);
        return await response.value();
    }
}
exports.InfoApi = InfoApi;
